
import React, { Component } from 'react';
import igtv from '../../images/socialIcons/igtv-24.png';
import refresh from '../../images/socialIcons/refresh.png';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faTrash, faDownload } from '@fortawesome/fontawesome-free-solid';
import './instagram.css'
import Loader from 'react-loader';
import {
    Row, Col, Media,
    FormGroup, Label,
    Input, InputGroup, InputGroupAddon, TextField,
    Modal, ModalHeader, ModalBody, NumericInput
} from 'reactstrap';
import Form from 'react-validation/build/form';
import { faTimes } from '@fortawesome/fontawesome-free-solid';
import Button from 'react-validation/build/button';

import insta_poster from '../../images/socialIcons/insta_poster.jpg';
import $ from 'jquery';
import _ from 'lodash';
import ToggleButton from 'react-toggle-button';
import moment from 'moment';
class InstagramPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            instagram_list: [],
            startLoader: true,
            showBroadcastHistory: false,
            instagram_id: "",
            stream_key: "",
            title: "Live Broadcast via Relay Stream",
            instagram_history: [],
            otpModal: false,
            instagramOtp: '',
            otpBodyResult: {},
        };
    }
    componentDidMount = () => {
        this.getLoggedInInstagramList();
        this.setState({
            stream_key: "Ainda não disponível, crie uma nova transmissão👇"
        })
    }

    getLoggedInInstagramList = () => {
        $.ajax({
            method: 'GET',
            url: '/api/v1/instagram/logged-in',
            success: function (success) {
                this.setState({
                    instagram_list: success.response
                })
            }.bind(this),
            error: function (err) {
                console.error(err);
            }.bind(this)
        });
    }

    getInstagramLoggedInList = () => {
        return _.map(this.state.instagram_list, (list, i) => {
            return <option key={"i-" + i} value={list.value}>{list.label}</option>;
        })
    }
    disableOtpInstagramModal = () => {
        this.setState({ otpModal: !this.state.otpModal })
    }
    submitInstagramOtp = (event) => {
        event.preventDefault();
        if (this.state.instagramOtp.length == 6) {
            this.setState({
                otpModal: !this.state.otpModal
            })
            this.submitOtpWithBody();
        }
    }
    onChangeOtpText = (e) => {
        this.setState({ instagramOtp: e.target.value });
    }


    submitOtpWithBody = () => {
        let self = this;
        let data = this.state.otpBodyResult;
        data.verifiedToken = this.state.instagramOtp;
        data.startBroadcast = true;
        data.isMannual = true;
        this.setState({
            startLoader: !this.state.startLoader
        })
        $.ajax({
            method: 'POST',
            url: '/api/v1/instagram/verification/otp',
            data: JSON.stringify(data),
            success: (success) => {
                this.setState({
                    startLoader: !this.state.startLoader
                })
                self.props.notifySuccess(success.message);
            },
            error: (err) => {
                this.setState({
                    startLoader: !this.state.startLoader,
                    otpModal: true
                })
                self.props.notifyError(err.responseJSON.message);
            }
        });
    }

    createInstagramStreamKey = (event) => {
        event.preventDefault();
        if (!+this.state.instagram_id) return;
        this.setState({
            startLoader: !this.state.startLoader
        })
        $.ajax({
            method: 'POST',
            url: '/api/v1/instagram/stream-key',
            data: JSON.stringify({ id: this.state.instagram_id, title: this.state.title }),
            success: function (success) {
                if (success.response && success.response.two_factor_identifier) {
                    this.setState({
                        otpModal: !this.state.otpModal,
                        instagramOtp: '',
                        otpBodyResult: success.response,
                        startLoader: !this.state.startLoader
                    })
                } else {
                    this.setState({
                        stream_key: success.response.streamKey,
                        startLoader: !this.state.startLoader
                    })
                }

                this.props.notifySuccess(success.message);
            }.bind(this),
            error: function (error) {
                this.setState({
                    startLoader: !this.state.startLoader
                })
                this.props.notifyError(error.responseJSON.message);
            }.bind(this)
        });
    }

    getSelectedAccount = (event) => {
        this.setState({ instagram_id: event.target.value, stream_key: "Ainda não disponível, crie uma nova transmissão👇" })
        if (!+event.target.value) {
            this.setState({ instagram_history: [] })
            return;
        }
        $.ajax({
            method: 'POST',
            url: '/api/v1/instagram/history',
            data: JSON.stringify({ id: event.target.value }),
            success: function (success) {
                this.setState({
                    instagram_history: success.response
                })
            }.bind(this),
            error: function (err) {
                console.error(err);
            }.bind(this)
        });
    }
    saveInstagramVideoOnIgtv = (event, history) => {
        let startDate = new Date(history.createdAt.toString()).getTime();
        let endDate = new Date(history.updatedAt.toString()).getTime();
        let streamTimeDifference = (endDate - startDate) / 1000;
        let currentDate = new Date().getTime();
        let stopedTimeDifference = (currentDate - endDate) / 1000;
        return;
        if (stopedTimeDifference >= streamTimeDifference) {
            let timeleft = stopedTimeDifference - streamTimeDifference;
            console.log(timeleft)
            return this.props.notifyError(`You can saved story after ${timeleft} seconds.`)
        } else {
            $.ajax({
                method: 'POST',
                url: '/api/v1/instagram/save-story',
                data: JSON.stringify({ id: history.broadcast_id, instagram_id: history.instagramId }),
                success: function (success) {
                    this.props.notifySuccess(success.message);
                }.bind(this),
                error: function (err) {
                    this.props.notifyError(err.responseJSON.message);
                }.bind(this)
            });
        }
    }

    updateInstagramTitle = (event) => {
        this.setState({
            title: event.target.value
        })
    }

    getBroadcastHistory = () => {
        return _.map(this.state.instagram_history, (history, i) => {
            return (<tr key={'i' + i}>
                <td>{history.title || 'N/A'}</td>
                <td>{history.description || 'N/A'}</td>
                <td>{history.duration || 'N/A'}</td>
                <td>{moment(history.createdAt).format("DD/MM/YYYY hh:mm A")}</td>
                <td><ToggleButton value={history.is_saved} onToggle={(event) => !history.is_saved ? null : this.saveInstagramVideoOnIgtv(event, history)} /></td>
            </tr>)
        })
    }
    mouseoverPass = (event) => {
        event.target.type = 'text';
    }
    mouseoutPass = (event) => {
        event.target.type = 'password';
    }
    render() {
        return (
            <div className="container">

                <div className='row mt-4'>
                    <div className='col'>
                        <form>
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <label className="input-group-text">Selecione a conta do Instagram</label>
                                </div>
                                <select className="custom-select" onChange={this.getSelectedAccount}>
                                    <option>Selecionar conta do instagram</option>
                                    {this.getInstagramLoggedInList()}
                                </select>
                            </div>

                            <div className="form-group">
                                <label >SERVIDOR INSTAGRAM RTMPS:</label>
                                <input type="text" className="form-control" aria-describedby="emailHelp" name="rtmps" defaultValue="rtmps://live-upload.instagram.com:443/rtmp/" disabled />
                            </div>
                            <div className="form-group">
                                <label >CHAVE DE FLUXO:</label>
                                <input type="password" className="form-control" aria-describedby="emailHelp" name="rtmps" defaultValue={this.state.stream_key} disabled onMouseOver={this.mouseoverPass} onMouseOut={this.mouseoutPass} />
                            </div>
                            <div className="form-group">
                                <label >TÍTULO DE TRANSMISSÃO:</label>
                                <input type="text" className="form-control" aria-describedby="emailHelp" name="rtmps" defaultValue={this.state.title} onChange={this.updateInstagramTitle} />
                            </div>
                            <button type="button" className="btn btn-primary" onClick={this.createInstagramStreamKey}>Criar nova transmissão</button>
                        </form>
                        {/* <button type="button" className="btn btn-secondary btn-sm mt-5 w-100">Show Broadcast History</button> */}
                    </div>
                    <div className='col col-lg-4'>
                        <video width="100%" height="100%" poster={insta_poster} className='insta-video'>
                            <source src="movie.mp4" type="video/mp4" />
                            <source src="movie.ogg" type="video/ogg" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
                <div className='mt-5'>
                    <h3>Histórico de transmissão do Instagram</h3>
                    <div className="table-wrapper-scroll-y my-custom-scrollbar">
                        <table className="table table-striped header-fixed ">
                            <thead>
                                <tr>
                                    <th scope="col">Título</th>
                                    <th scope="col">Descrição</th>
                                    <th scope="col">Duração</th>
                                    <th scope="col">Hora de criação</th>
                                    <th scope="col">Salvo no IGTV</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.getBroadcastHistory()}
                            </tbody>
                        </table>
                    </div>
                </div>
                <Loader loaded={this.state.startLoader}></Loader>
                <Modal isOpen={this.state.otpModal} >
                    <ModalBody className="otpInputModal">
                        <Form className="DataFields" onSubmit={this.submitInstagramOtp}>
                            <span onClick={this.disableOtpInstagramModal} className="closeModalBtn"><FontAwesomeIcon icon={faTimes} /></span>
                            <div className="row">
                                <div className="col-sm-3 otpInput">
                                    <label className="submitButton">Digite OTP</label>
                                </div>
                                <div className="col-sm-6">
                                    <Input type="number" name="otp" value={this.state.instagramOtp} autoComplete="off" placeholder="Digite otp de 6 dígitos" onChange={this.onChangeOtpText} className="form-control" />
                                </div>
                            </div>
                            <FormGroup className="text-center submitButton">
                                <Button type="submit" className="btn btn--submit mx-auto">Enviar</Button>
                            </FormGroup>
                        </Form>
                    </ModalBody>
                </Modal>
            </div>)
    }
}
export default InstagramPage;


// WEBPACK FOOTER //
// ./src/components/Instagram/index.js